import styled from '@emotion/styled';

import AlertIcon from '@/assets/icons/icon_alert.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Container = styled.div(() =>
  mq({
    position: 'relative',
    padding: '24px',
    backgroundColor: defaultTheme.color.errorBg,
    border: `1px solid ${defaultTheme.color.error}`,
    textAlign: 'center',
  }),
);

export const Icon = styled.i(() =>
  mq({
    display: 'inline-block',
    background: `url(${AlertIcon}) no-repeat center`,
    backgroundSize: 'contain',
    marginBottom: defaultTheme.spacing.s,
    width: '28px',
    height: '24px',
    textAlign: 'center',
  }),
);

export const Title = styled.h4(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    color: defaultTheme.color.error,
    lineHeight: defaultTheme.font.height.l,
    textAlign: 'center',
    marginBottom: '12px',
  }),
);

export const CheckBoxContainer = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    textAlign: 'left',
  }),
);

export const CheckboxWrapper = styled.div(() =>
  mq({
    ':not(:last-child)': {
      marginBottom: defaultTheme.spacing.l,
    },
  }),
);

export const Notice = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    marginTop: defaultTheme.spacing.s,
    marginLeft: defaultTheme.spacing.xxl,
    paddingLeft: '1em',
    textIndent: '-1em',
  }),
);

export const ChocomNotice = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    marginTop: defaultTheme.spacing.l,
  }),
);

export const CreditNotice = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    paddingTop: '3px',
    div: {
      paddingTop: defaultTheme.spacing.s,
      paddingBottom: defaultTheme.spacing.s,
      a: {
        textDecorationLine: 'underline',
        fontWeight: 'bold',
      },
    },
    span: {
      fontSize: defaultTheme.font.size.xs,
      a: {
        textDecorationLine: 'underline',
      },
    },
  }),
);

export const CreditDormantWrapper = styled.div(() =>
  mq({
    margin: `${defaultTheme.spacing.xxl} auto 0`,
    textAlign: 'center',
  }),
);

export const CreditDormantTitle = styled.p(() =>
  mq({
    fontWeight: 'bold',
    color: defaultTheme.text.error,
    fontSize: defaultTheme.font.size.m,
  }),
);

export const CreditDormantNote = styled.p(() =>
  mq({
    marginTop: defaultTheme.spacing.m,
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.s,
  }),
);

export const CreditDormantLink = styled.div(() =>
  mq({
    marginTop: defaultTheme.spacing.m,
    '& > a': {
      color: defaultTheme.text.gray,
      fontSize: defaultTheme.font.size.s,
      textDecorationLine: 'underline',
      ...hoverOpacity,
    },
  }),
);

export const ExternalLink = styled.a(() =>
  mq({
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);
